import { render, staticRenderFns } from "./ProduceAdd.vue?vue&type=template&id=27b25c3b&"
import script from "./ProduceAdd.vue?vue&type=script&lang=js&"
export * from "./ProduceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports